import * as React from "react"

import type { ErrorEntry, ModalAction } from "../error-catalog"
import { executeAction, type ActionContext } from "../action-executor"

interface Props {
  entry: ErrorEntry
  ctx: ActionContext
  onTrackClick?: (action: ModalAction) => void
}

/**
 * Variante `redirect`: un botón que normalmente envía al usuario a otra URL
 * (la landing principal, otra experiencia, etc.). Visualmente idéntica a
 * `primary-cta`, pero se separa para hacer el intent del catálogo más legible
 * y para permitir overrides visuales futuros (ej. ícono de flecha de salida).
 */
export const RedirectLayout: React.FC<Props> = ({ entry, ctx, onTrackClick }) => {
  const handleClick = () => {
    onTrackClick?.(entry.primaryCta.action)
    executeAction(entry.primaryCta.action, ctx)
  }

  return (
    <div className="text-center px-6 py-10 sm:py-12">
      {entry.icon && <div className="mx-auto mb-4 flex justify-center">{entry.icon}</div>}
      <h2 className="text-primary-800 text-xl sm:text-2xl font-semibold mb-3">
        {entry.title}
      </h2>
      {entry.description && (
        <div className="text-sm leading-[1.3] text-normal mb-6">
          {entry.description}
        </div>
      )}
      <button
        type="button"
        className="w-[260px] py-2.5 bg-active hover:bg-active2 text-white text-base font-semibold rounded-3xl shadow-[0px_2px_10px_rgba(161,161,161,.25)]"
        onClick={handleClick}
      >
        {entry.primaryCta.label}
      </button>
    </div>
  )
}
